import React from "react";
import "./Card.scss";

const CommonCard = ({ children, className = "" }) => {
  return <div className={`common-card ${className}`}>{children}</div>;
};

export default CommonCard;
